import { useDispatch, useSelector } from 'react-redux';
import { selectAppliedOffers, selectEligibleOffers, setOffers } from '../../../../store/slices/OfferSlice';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import useOffersTranslations from '../useOffersTranslations';
import { useTranslation } from 'react-i18next';

const useWatchAppliedOffers = () => {
  const eligibleOffers = useSelector(selectEligibleOffers);
  const appliedOffers = useSelector(selectAppliedOffers);
  const { getLabelByOffer } = useOffersTranslations();
  const dispatch = useDispatch();
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:Watchers' });
  const appliedOffersHandler = (): void => {
    if (!appliedOffers?.length) {
      return;
    }

    const invalidOffers = appliedOffers.filter(
      (appliedOffer) => !eligibleOffers.some((offer) => offer.id === appliedOffer.id),
    );

    if (!invalidOffers.length) {
      return;
    }

    const validOffers = appliedOffers.filter(
      (appliedOffer) => !invalidOffers.some((offer) => offer.id === appliedOffer.id),
    );

    dispatch(setOffers({ appliedOffers: validOffers }));

    const copy = t('removed', { count: invalidOffers.length, offer: getLabelByOffer(invalidOffers[0]) });

    toast.error(copy, {
      duration: 5000,
      position: 'bottom-center',
    });
  };

  useEffect(() => {
    appliedOffersHandler();
  }, [eligibleOffers, appliedOffers]);
};

export default useWatchAppliedOffers;
